<template>
  <div class="digital-clock text-center text-medium-primary">
    <span>{{ currentTime.hours }}</span> :
    <span>{{ currentTime.minutes }}</span> :
    <span>{{ currentTime.seconds }}</span>
  </div>
</template>

<script>
export default {
  name: "MoleculeDisplayCurrentTime",

  data() {
    return {
      intervalId: null,
      currentTime: {
        hours: "",
        minutes: "",
        seconds: "",
      },
    }
  },

  mounted() {
    this.updateTime()
    this.intervalId = setInterval(() => {
      this.updateTime()
    }, 1000)
  },

  beforeDestroy() {
    clearInterval(this.intervalId)
  },

  methods: {
    updateTime() {
      const now = new Date()
      this.currentTime.hours = this.padNumber(now.getHours())
      this.currentTime.minutes = this.padNumber(now.getMinutes())
      this.currentTime.seconds = this.padNumber(now.getSeconds())
    },
    padNumber(number) {
      return number < 10 ? "0" + number : number
    },
  },
}
</script>

<style lang="scss" scoped>
.digital-clock {
  font-size: 2em;
}
</style>
